var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"burger",class:_vm.vModel ? 'burger--active' : '',on:{"click":function($event){_vm.vModel = !_vm.vModel}}},[_c('div',{staticClass:"burger__item burger__item-1"}),_c('div',{staticClass:"burger__item burger__item-2"})])}
var staticRenderFns = []

export { render, staticRenderFns }